import React, { useEffect, useState } from 'react';
import {
  Box,
  Heading,
  Text,
  Badge,
  VStack,
  HStack,
  Divider,
  Image,
  Flex,
  CircularProgressLabel,
  CircularProgress,
  SimpleGrid,
  Tooltip,
} from '@chakra-ui/react';
import ScoreboardOverlay from './Scoreboard';
import { COLORS } from '../../constants';

function ActiveGames({
  socio,
  games,
  handleFinishGame,
  finishLoading,
  fetchActiveGames,
}) {
  const [expandedGameId, setExpandedGameId] = useState(null);

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleString();
  };

  const expandedGame =
    expandedGameId && games.length
      ? games.find((g) => g.documentId === expandedGameId)
      : null;

  useEffect(() => {
    const interval = setInterval(() => {
      fetchActiveGames();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Box
        bg="#3b235a"
        p={6}
        borderRadius="lg"
        boxShadow="md"
        mb={10}
        color="white"
      >
        <Heading
          as="h2"
          size="lg"
          mb={4}
          color="#ffcc00"
          textAlign="center"
          textShadow="0 0 6px #000"
        >
          Partite Attive
        </Heading>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
          {games.length > 0 ? (
            games.map((game) => {
              const canUserClick =
                (!game.End_Time &&
                  game.Participants.find(
                    ({ playerId }) => playerId === socio.documentId
                  )) ||
                socio.user.type === 'admin';

              return (
                <Box
                  key={game.documentId}
                  border="2px solid #3eb297"
                  borderRadius="xl"
                  p={5}
                  bg="white"
                  color="#3b235a"
                  boxShadow="lg"
                  transition="transform 0.24s"
                  _hover={{
                    transform: canUserClick ? 'scale(1.02)' : 'none',
                    cursor: canUserClick ? 'pointer' : 'default',
                  }}
                  onClick={() => {
                    if (canUserClick) setExpandedGameId(game.documentId);
                  }}
                >
                  <HStack justifyContent="space-between" mb={3}>
                    <Heading as="h3" size="md">
                      {game.Name}
                    </Heading>
                    <Badge
                      px={2}
                      py={1}
                      borderRadius="md"
                      fontSize="0.75rem"
                      color="white"
                      bg={game.End_Time ? '#e73341' : '#3eb297'}
                    >
                      {game.End_Time ? 'Concluso' : 'Attivo'}
                    </Badge>
                  </HStack>

                  <VStack spacing={1} align="start" fontSize="sm">
                    <Text>
                      <strong>Formato:</strong> {game.Format}
                    </Text>
                    <Text>
                      <strong>Tavolo:</strong> {game.Table_Name}
                    </Text>
                    <Text>
                      <strong>Creato:</strong> {formatDate(game.createdAt)}
                    </Text>
                    <Text>
                      <strong>Punteggio Iniziale:</strong> {game.Initial_Score}
                    </Text>
                    {game.End_Time && (
                      <Text>
                        <strong>Terminata:</strong> {formatDate(game.End_Time)}
                      </Text>
                    )}
                  </VStack>

                  {game.Participants && game.Participants.length > 0 && (
                    <Box mt={4}>
                      <Divider mb={3} borderColor="#3eb297" />
                      <Heading as="h4" size="sm" mb={2} color="#36a9e1">
                        Partecipanti:
                      </Heading>
                      <VStack
                        bg="#f5f5f5"
                        align="stretch"
                        spacing={2}
                        borderRadius="md"
                        p={2}
                      >
                        {game.Participants.map((participant) => (
                          <Flex
                            key={participant.playerId}
                            p={2}
                            bg="white"
                            borderRadius="md"
                            justifyContent="space-between"
                            alignItems="center"
                            border="1px solid #ccc"
                          >
                            <Box>
                              <Text fontSize="xs" fontWeight="bold" mb={1}>
                                {participant.playerName} (#
                                {participant.cardNumber})
                              </Text>
                              <HStack spacing={1}>
                                {participant.colors.map((colorCode) => (
                                  <Tooltip
                                    key={`${participant.playerId}-${colorCode}`}
                                    label={colorCode}
                                    hasArrow
                                  >
                                    <Image
                                      src={COLORS[colorCode]}
                                      alt={colorCode}
                                      boxSize="18px"
                                    />
                                  </Tooltip>
                                ))}
                              </HStack>
                            </Box>
                            <CircularProgress
                              max={game.Initial_Score}
                              value={
                                participant.score < 0 ? 0 : participant.score
                              }
                              size="48px"
                              color="#ffcc00"
                              thickness="10px"
                            >
                              <CircularProgressLabel
                                fontSize="sm"
                                fontWeight="bold"
                                color="#3b235a"
                              >
                                {participant.score}
                              </CircularProgressLabel>
                            </CircularProgress>
                          </Flex>
                        ))}
                      </VStack>
                    </Box>
                  )}
                </Box>
              );
            })
          ) : (
            <Text fontSize="lg" color="#ffcc00" textAlign="center">
              Nessuna partita attiva al momento.
            </Text>
          )}
        </SimpleGrid>
      </Box>

      {expandedGame && (
        <ScoreboardOverlay
          expandedGame={expandedGame}
          setExpandedGameId={setExpandedGameId}
          finishLoading={finishLoading}
          onFinishGame={(args) => {
            setExpandedGameId('');
            handleFinishGame(args);
          }}
        />
      )}
    </>
  );
}

export default ActiveGames;
